export default __webpack_public_path__ + "static/ti-alpine-rd-germany-516af0522f20ad99125f0441bcf2f135.jpg";